
import { defineComponent } from 'vue';
import {
  ContentBlock,
  Matomo,
} from 'CoreHome';

export default defineComponent({
  props: {
    resetUrl: String,
    formNonce: String,
  },
  components: {
    ContentBlock,
  },
  computed: {
    tokenAuth() {
      // read from the global Matomo already publishes on every page, the same way AjaxHelper does,
      // rather than rendering another copy of the token into the markup
      return Matomo.token_auth;
    },
  },
  methods: {
    resetCredentials(event: Event) {
      Matomo.helper.modalConfirm(
        this.$refs.confirmResetCredentials as HTMLElement,
        {
          yes() {
            (event.target as HTMLFormElement).submit();
          },
        },
      );
    },
  },
});
